import React, { useContext, useEffect, useState } from "react";
import "./Contact_Us.css";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faMapLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Message_Lottie } from "../lotties/message-lottie/Message_Lottie";
import Full_Screen_Modal from "../full-screen-modal/Full_Screen_Modal";
import Success_Modal from "../success-modal/Success_Modal";
import { Context } from "../../utils/context";
import { GetSocialLink } from "../../utils/apis/master/Master";
import { ContactUsForm } from "../../utils/apis/form/form";

const Contact_Us = () => {


  const {
    IMG_URL,
    appSetup
  } = useContext(Context);
  const [showMap, setShowMap] = useState(false);
  const [apiError, setApiError] = useState("");
  const {
    register,
    handleSubmit,
    getValues, reset,
    formState: { errors },
  } = useForm();
  const [formSubmitted] = useState(false);

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);


  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    try {

      const sendData = new FormData();

      sendData.append("first_name", data?.name || "");
      sendData.append("email", data?.email || "");
      sendData.append("contact_no", data?.contact_no || "");
      sendData.append("message", data?.message || "");
      const response = await ContactUsForm(sendData);
      if (response.success) {
        reset()
        setShowModal(true);
        setTimeout(() => {
          navigate("/");
          setShowModal(false);
        }, 2500);
      } else {
        setApiError(response?.errors)
        console.error("Form submission failed:", response?.errors);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };



  return (
    <section className="Contact_Us About_Banner">
      <div className="container-fluid">
        <div className="About_Banner_holder">
          <h5 className="about_us">Contact Us</h5>
        </div>
        <div className="container">
          <div className={`contact_form_holder ${showMap ? "map_active" : ""}`}>
            <div className="contact_us_container">
              <Form
                className="contact_us_form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="form_group">
                  <Form.Control
                    type="text"
                    placeholder="Enter Name"
                    {...register("name", {
                      required: "Full name is required",
                      minLength: {
                        value: 3,
                        message: "Name must be at least 3 characters",
                      },
                      maxLength: {
                        value: 50,
                        message: "Name cannot exceed 50 characters",
                      },
                      pattern: {
                        value: /^[A-Za-z\s]+$/,
                        message: "Name can only contain letters and spaces",
                      },
                    })}
                  />
                  {errors.name && (
                    <span className="error">{errors.name?.message}</span>
                  )}
                </div>

                <div className="form_group">
                  <Form.Control
                    type="email"
                    placeholder="Email Address"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                        message: "Enter a valid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <span className="error">{errors?.email?.message}</span>
                  )}
                </div>

                <div className="form_group">
                  <Form.Control
                    placeholder="Contact Number"
                    type="text"
                    name="contact_no"
                    maxLength={10} // restrict typing to 10 digits
                    {...register("contact_no", {
                      required: "Contact Number is required",
                      pattern: {
                        value: /^[0-9]+$/,  // only numbers
                        message: "Only digits are allowed",
                      },
                      minLength: {
                        value: 10,
                        message: "Contact Number must be exactly 10 digits",
                      },
                      maxLength: {
                        value: 10,
                        message: "Contact Number must be exactly 10 digits",
                      },
                    })}
                  />

                  {errors.contact_no && (
                    <span className="error">{errors?.contact_no?.message}</span>
                  )}
                </div>

                <div className="form_group full_width">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Type your message here..."
                    {...register("message", { required: "Message is required" })}
                  />
                  {errors.message && (
                    <span className="error">{errors?.message?.message}</span>
                  )}
                </div>

                {apiError && (
                  <span className="error">{apiError}</span>
                )}

                <button type="submit" className="send_btn">
                  Submit
                </button>
              </Form>

              <div className="contact_us_info">
                <div className="info_item">
                  <div className="icon_div">
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{ color: "#20446E" }}
                    />
                  </div>
                  <p>{appSetup?.contact_no || ""}</p>
                </div>

                <div className="info_item">
                  <div className="icon_div">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ color: "#20446E" }}
                    />
                  </div>
                  <p>{appSetup?.email || ""}</p>
                </div>

                <div className="info_item">
                  <div className="icon_div">
                    <FontAwesomeIcon
                      icon={faLocationDot}
                      style={{ color: "#20446E" }}
                    />
                  </div>
                  <p>{appSetup?.address || ""}</p>
                </div>

                <div
                  className="info_item map_link"
                  onClick={() => setShowMap(true)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="icon_div">
                    <FontAwesomeIcon
                      icon={faMapLocationDot}
                      style={{ color: "#20446E" }}
                    />
                  </div>
                  <p>Find Us on Map</p>
                </div>
              </div>
            </div>
            <div className="map_wrapper">
              <button
                className="map_close_btn"
                onClick={() => setShowMap(false)}
              >
                &times;
              </button>

              <div className="map_section">
                <iframe
                  title="Location Map"
                  src={`https://www.google.com/maps?q=${encodeURIComponent(appSetup?.address || "")}&output=embed`}
                  style={{ border: 0, width: "100%", height: "400px" }}
                  allowFullScreen=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Success_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        successText="Form Submitted!"
      />


      {/* maxLength={10} // restrict typing to 10 digits
      {...register("contact_no", {
        required: "Contact Number is required",
        pattern: {
          value: /^[0-9]+$/,  // only numbers
          message: "Only digits are allowed",
        },
        minLength: {
          value: 10,
          message: "Contact Number must be exactly 10 digits",
        },
        maxLength: {
          value: 10,
          message: "Contact Number must be exactly 10 digits",
        },
      })}
        
      
      
      
      {...register("email", {
        required: "Email is required",
        pattern: {
          value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
          message: "Enter a valid email address",
        },
      })} 
        
      
      
      {...register("name", {
        required: "Full name is required",
        minLength: {
          value: 3,
          message: "Name must be at least 3 characters",
        },
        maxLength: {
          value: 50,
          message: "Name cannot exceed 50 characters",
        },
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: "Name can only contain letters and spaces",
        },
      })} */}
    </section>
  );
};

export default Contact_Us;
